declare global {
    interface Window {
        dataLayer?: Object[];
        gtag?: (...args: any[]) => void;
    }
}

import { type ConsentProvider } from "./consent-manager";

type ConsentType = 'default' | 'update';
type ConsentStatus = 'granted' | 'denied';

interface ConsentState {
    ad_storage: ConsentStatus;
    ad_user_data: ConsentStatus;
    ad_personalization: ConsentStatus;
    analytics_storage: ConsentStatus;
    functionality_storage: ConsentStatus;
    personalization_storage: ConsentStatus;
    security_storage: ConsentStatus;
}

const DEFAULT_CONSENT_STATE: ConsentState = {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted'
};

const getConsentState = (consent: ConsentStatus): ConsentState => ({
    ...DEFAULT_CONSENT_STATE,
    ad_storage: consent,
    ad_user_data: consent,
    ad_personalization: consent,
    analytics_storage: consent
});

const initializeGoogleTags = () => {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
        (window.dataLayer || []).push(arguments);
    };
};

const updateConsentState = (isGranted: boolean) => {
    const consentState = getConsentState(isGranted ? 'granted' : 'denied');
    (window.gtag as any)('consent', 'update', consentState);
    (window.dataLayer as any[]).push({
        event: 'consent_update',
        consent_mode: consentState
    });
};

const setDefaultConsentState = () => {
    (window.gtag as any)('consent', 'default', DEFAULT_CONSENT_STATE);
    (window.dataLayer as any[]).push({
        event: 'default_consent',
        consent_mode: DEFAULT_CONSENT_STATE
    });
};

export const googleConsentManager: ConsentProvider = {
    handleInitialConsent: (isGranted: boolean | undefined) => {
        if (typeof window === 'undefined') return;

        initializeGoogleTags();
        setDefaultConsentState();

        if (isGranted !== undefined) {
            updateConsentState(isGranted);
        }
    },

    handleConsentUpdate: (isGranted: boolean) => {
        if (typeof window === 'undefined') return;

        initializeGoogleTags();
        updateConsentState(isGranted);
    },
};